import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	.form-container {
		padding: 12em 0 0;
		background-color: #f3f3f3;
	}

	#results {
		&:before {
			content: '';
			display: block;
			height: 150px;
			margin: -150px 0 0;
		}
	}

	.search-modal {
		.public-layout-modals-job-login-modal {
			.layout-modal {
				.modal-container {
					top: 56%;
					padding: 1.3em 2em 1em 2em;

					.google-recaptcha {
						padding: 0;
						margin: 0 0 1em 0;
					}

					.public-layout-forms-form-footer {
						display: flex;
						flex-flow: row wrap;
						gap: 1em;

						.footer-title {
							margin-top: 1em;
							width: 100%;
						}

						.layout-google-login,
						.layout-facebook-login {
							width: calc(50% - 1em);

							.button {
								.button-content {
									display: none;
								}
							}
						}
						.footer {
							margin: 0 auto;
							padding: 0;
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		.public-page-offers-section-filters {
			display: none;
		}

		#results {
			&:before {
				height: 50px;
				margin: -50px 0 0;
			}
		}

		.search-modal {
			.public-layout-modals-job-login-modal {
				.layout-modal {
					.modal-container {
						top: 9%;
						padding: 1.3em 2em 1em 2em;
					}
				}
			}
		}
	}
`;
